import { init, track, Types } from '@amplitude/analytics-browser'

enum Project {
  Facilities = '459a1cb2b748aa1c92e594287794ca12',
}

export function initTracking(
  project: keyof typeof Project,
  defaultProperties = {},
  options?: Types.BrowserOptions
) {
  const apiKey = Project[project]
  init(apiKey, options)
  _defaults = defaultProperties
}

let _defaults = {}

export function updateDefaultTrackingProperties(properties: object) {
  _defaults = { ..._defaults, ...properties }
}

export function trackEvent(eventName: string, properties?: object) {
  track(eventName, { ..._defaults, ...properties })
}
